import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import PictureComp from '@/components/picture/PictureComp.vue';
import GridBuyBox from '@/features/buybox/components/grid/GridBuyBox.vue';
import TitleScoreList from '@/components/TitleScoreList.vue';
import PosterGraphql from '@/components/poster/PosterGraphql.vue';
import Popover from '@/ui-components/Popover.vue';

import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { faCheck, faEllipsisVertical, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';

import type { TitleEdge } from '@/features/editorial/types/editorial-types';

import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { useTitleWatchlist } from '@/helpers/composables/useTitleWatchlist';
import { isInDislikeList, isInLikeList, useListActions } from '@/helpers/composables/useListActions';
import { useEditorialTracking } from '@/features/editorial/tracking';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListArticleListItem',
  props: {
    title: null,
    index: null,
    titleOrderMode: null,
    totalCount: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleEdge;
	index: number;
	titleOrderMode: string | null;
	totalCount?: number;
};

const { trackEditorial } = useEditorialTracking();



const languageStore = useLanguageStore();

const { setInLikelist, setInDislikelist, setInSeenlist } = useListActions(undefined);
const { setInWatchlist } = useTitleWatchlist(undefined);

const shortDescription = computed(() => {
	const override = props.title.data.overrides?.find(o => o.languageOrLocale === languageStore.language);
	return override?.shortDescription || props.title.node.content.shortDescription;
});

const formattedPosition = computed(() => {
	const pos = props.titleOrderMode === 'descending' ? (props.totalCount ?? 0) - props.index : props.index + 1;
	return pos.toLocaleString(languageStore.locale.replace('_', '-'), {
		minimumIntegerDigits: 2,
		useGrouping: false,
	});
});

const isInWatchlist = computed(() => {
	return !!props.title?.node.watchlistEntryV2?.createdAt;
});

const isTitleInLikeList = computed(() => isInLikeList(props.title.node));
const isTitleInDislikeList = computed(() => isInDislikeList(props.title.node));

const isTitleInSeenlist = computed(() =>
	'seenState' in props.title.node
		? props.title.node.seenState.progress === 100
		: !!props.title.node.seenlistEntry?.createdAt
);

const titleDetails = computed(() => ({
	title: props.title.node.content.title,
	objectId: props.title.node.objectId,
	objectType: props.title.node.objectType,
}));

function addToWatchList() {
	setInWatchlist(props.title.node.id, isInWatchlist.value, titleDetails.value, {
		label: 'sqtv',
		source: 'lists-panel',
	});
}

function addToLikeList() {
	setInLikelist(props.title.node.id, isTitleInLikeList, isTitleInDislikeList, titleDetails);
}

function addToDislikeList() {
	setInDislikelist(props.title.node.id, isTitleInLikeList, isTitleInDislikeList, titleDetails);
}

function addToSeenList() {
	setInSeenlist(props.title.node.id, isTitleInSeenlist, titleDetails);
}

function handlePopover(isOpen: boolean) {
	trackEditorial('togglePopover', { spec: { action: isOpen ? 'opened' : 'closed' } });
}

return { __sfc: true,trackEditorial, props, languageStore, setInLikelist, setInDislikelist, setInSeenlist, setInWatchlist, shortDescription, formattedPosition, isInWatchlist, isTitleInLikeList, isTitleInDislikeList, isTitleInSeenlist, titleDetails, addToWatchList, addToLikeList, addToDislikeList, addToSeenList, handlePopover, PictureComp, GridBuyBox, TitleScoreList, PosterGraphql, Popover, faBookmark, faCheck, faEllipsisVertical, faThumbsDown, faThumbsUp }
}

})